import jump from 'jump.js';

export default class ScrollTo {
  constructor(el) {
    this.el = el;
    this.addEventListeners();
  }

  static get ANIMATING_TIMING() {
    return 500;
  }

  addEventListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this), false);
  }

  handleClick(evt) {
    let target = evt.currentTarget.getAttribute('href');

    target = document.querySelector(target);

    if (target) {
      evt.preventDefault();
      jump(target, {
        duration: ScrollTo.ANIMATING_TIMING,
        offset: document.body.classList.contains('admin-bar') ? -32 : 0,
        callback: () => {
          window.location.hash = `#${target.id}`;
        },
        a11y: true
      });
    }
  }

  static init() {
    const links = [...document.querySelectorAll('a[data-scrollto]')];

    links.forEach(link => {
      new ScrollTo(link);
    });
  }
}
